import axios from '@axios';

const base = '/api/v1/call-events';

export default {
  createGeneralEvent(dto) {
    return axios.post(`${base}/create/general`, dto);
  },
  getChatMessages(visitId) {
    return axios.get(`${base}/chat-messages/${visitId}`);
  },
};
